import * as React from 'react';
import {User} from 'oidc-client';
import {Link, Tooltip} from "@mui/material";
import Loading from "./Loading";
import CircularProgress from "@mui/material/CircularProgress";

export interface SecurableDownloadLinkProps {
    user: User;
    path: string;
    children: React.ReactNode;
    showError: (error) => void;
    tooltip?: string;
}

export interface SecurableDownloadLinkState {
    isLoading: boolean;
}

export default class SecurableDownloadLink extends React.Component<SecurableDownloadLinkProps, SecurableDownloadLinkState> {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        }
    }

    private async downloadFile(url) {
        try {
            this.setState({isLoading: true});
            const token = this.props.user?.access_token;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/octet-stream',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (!response.ok) {
                throw new Error(`Error during file download: ${response.statusText}`);
            }

            const contentDisposition = response.headers.get('Content-Disposition');
            let fileName = '';

            if (contentDisposition) {
                const filenameRegex = /filename[^;=\n]*=(?:["']?)([^;"'\n]+)/;
                const match = contentDisposition.match(filenameRegex);

                if (match) {
                    fileName = match[1].trim();
                }
            } else {
                throw new Error(`Error during file download: not found`);
            }

            const blob = await response.blob();

            const downloadUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(downloadUrl);
            this.setState({isLoading: false});
        } catch (error) {
            this.setState({isLoading: false});
            console.error('Error during file download:', error);
            this.props.showError(`'Error during file download: ${error}`);
        }
    }

    public render() {
        return (
            <React.Fragment>
                <Tooltip title={this.props.tooltip}>
                <Link style={{cursor: "pointer"}}
                      onClick={() => this.downloadFile(this.props.path)}>{this.state.isLoading ? (<CircularProgress size={20} />) : this.props.children}</Link>
                </Tooltip>
            </React.Fragment>
        );
    }
}